export default __webpack_public_path__ + "static/title-about_sp-3e121aaac8af2a8d945a90df9ea3cc59.png";